const URL = "https://api.coingecko.com/api/v3/coins/";
//   "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=bitcoin";

export const getCoinsData = () => {
  const result = fetch(URL).then(res => res.json());
  return result;
};
